import styled from 'styled-components'
import { breakpoints } from '@awazevr/design-system.utils.react'

export const StyledKSPItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  p {
    margin: 0;
    padding: 0;
    height: auto;
    line-height: 0.875rem;
  }
`

export const StyledTabletKSPs = styled.div`
  margin-top: 12px;

  @media only screen and (max-width: ${breakpoints[0]}px) {
    display: none;
  }
`

export const StyledMobileKSPs = styled.div`
  margin-top: 12px;

  @media only screen and (min-width: ${breakpoints[0]}px) {
    display: none;
  }
`
